import { create } from 'zustand';
import { Role } from '@data/sdk/match';

interface BulkInvitesTableViewState {
  setTableView: (tableView: Role) => void;
  tableView: Role;
}

export const useBulkInvitesTableViewStore = create<BulkInvitesTableViewState>((set) => ({
  tableView: Role.PatientOrg,
  setTableView: (tableView: Role) => set(() => ({ tableView })),
}));
